import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sid = m[1];
    // clear hash immediately so refresh doesn't retry the same one-time-use sid
    window.history.replaceState(null, "", window.location.pathname);

    // Cross-remount de-dup: StrictMode dev double-mounts + one-time-use session_id
    // can trigger a second POST that fails 401. Track consumption in sessionStorage.
    const consumedKey = `vp_consumed_sid:${sid}`;
    if (sessionStorage.getItem(consumedKey)) {
      // Already handled this session_id in a prior mount — re-hydrate user.
      (async () => {
        try {
          const me = await api.get("/auth/me");
          setUser(me.data);
          navigate("/dashboard", { replace: true });
        } catch {
          navigate("/", { replace: true });
        }
      })();
      return;
    }
    sessionStorage.setItem(consumedKey, "1");

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        setUser(r.data.user);
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        // Recovery: maybe the first POST succeeded and set the cookie, but a
        // race/remount reported a follow-up 401. Check /auth/me before giving up.
        try {
          const me = await api.get("/auth/me");
          setUser(me.data);
          navigate("/dashboard", { replace: true });
          return;
        } catch {}
        const msg = e?.response?.data?.detail || "Giriş başarısız";
        console.error("Auth callback failed", msg);
        navigate("/?error=" + encodeURIComponent(msg), { replace: true });
      }
    })();
  }, [location, navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-sm text-zinc-500 label-overline">Oturum açılıyor…</div>
    </div>
  );
}
